var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 0.333496C5.1084 0.333496 0.333374 5.10852 0.333374 11.0002C0.333374 16.8918 5.1084 21.6668 11.0001 21.6668C16.8917 21.6668 21.6667 16.8918 21.6667 11.0002C21.6667 5.10852 16.8917 0.333496 11.0001 0.333496ZM14.5987 13.0903C15.0153 13.507 15.0153 14.182 14.5987 14.5987C14.1817 15.0156 13.5069 15.0153 13.0903 14.5987L11 12.5084L8.90977 14.5987C8.49284 15.0156 7.818 15.0153 7.40142 14.5987C6.98475 14.182 6.98475 13.507 7.40142 13.0903L9.49168 11.0001L7.40142 8.90989C6.98475 8.49323 6.98475 7.81821 7.40142 7.40154C7.81808 6.98487 8.49311 6.98487 8.90977 7.40154L11 9.49181L13.0903 7.40154C13.507 6.98487 14.182 6.98487 14.5987 7.40154C15.0153 7.81821 15.0153 8.49323 14.5987 8.90989L12.5084 11.0001L14.5987 13.0903Z",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1263a7fd.svg";
export { ForwardRef as ReactComponent };